import React, { useState } from "react";

import {
  PencilSquareIcon,
  Square2StackIcon,
  TrashIcon,
} from "@heroicons/react/24/outline";
import "rc-dropdown/assets/index.css";
import { MenuInfo } from "rc-menu/lib/interface";
import toast from "react-hot-toast";
import { generatePath, useNavigate } from "react-router-dom";

import { ROUTE_DESTINATIONS_EDIT } from "../../../../../constants/routes";
import { DestinationTypeMap } from "../../../../../enums/destination";
import useSelectedAccount from "../../../../../hooks/useSelectedAccount";
import { AllDestinations } from "../../../../../models";
import { useCopyDestinationMutation } from "../../../../../redux/services/destinations";

import ActionDropdown, {
  Action,
} from "../../../../../components/common/ActionDropdown";
import Button from "../../../../../components/form/Button";
import DestinationDeleteModal from "../../../../Destination/components/modals/DestinationDeleteModal";

enum Actions {
  COPY = "copy",
  DELETE = "delete",
}

const actions: Action[] = [
  {
    key: Actions.COPY,
    label: "Make a copy",
    icon: <Square2StackIcon className="size-4 text-gray-500" />,
  },
  {
    key: Actions.DELETE,
    label: "Delete",
    icon: <TrashIcon className="size-4 text-red-500" />,
  },
];
interface Props {
  destination: AllDestinations;
}

export const DestinationActionsColumn = ({ destination }: Props) => {
  const navigate = useNavigate();
  const { selectedAccount } = useSelectedAccount();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [copyDestination] = useCopyDestinationMutation();

  const handleSelect = async (info: MenuInfo) => {
    info.domEvent.stopPropagation();
    const key = info.key as Actions;

    if (key === Actions.COPY) {
      try {
        await copyDestination({
          accountId: selectedAccount?.accountId,
          destinationId: destination.destinationId,
        }).unwrap();
        toast.success("Successfully created a destination copy.");
      } catch (error) {
        console.error("Clone failed", error);
        toast.error("Failed to make a copy. Please try again.");
      }
    } else if (key === Actions.DELETE) {
      setShowDeleteModal(true);
    }
  };

  return (
    <>
      <div className="flex items-center gap-1">
        <Button
          paddingZero
          variant="light-primary"
          className="gap-1 flex items-center p-1"
          onClick={() =>
            navigate(
              generatePath(ROUTE_DESTINATIONS_EDIT, {
                id: destination.destinationId!,
              }) + `?type=${DestinationTypeMap[destination.destinationTypeId]}`
            )
          }
        >
          <PencilSquareIcon className="size-4" />
          <span className="md:hidden">Edit</span>
        </Button>
        <div className="h-4 w-px bg-gray-200" />
        <ActionDropdown
          actions={actions}
          onSelect={handleSelect}
        />
      </div>

      {showDeleteModal && (
        <DestinationDeleteModal
          destinationId={destination.destinationId}
          onRequestClose={() => {
            setShowDeleteModal(false);
          }}
        />
      )}
    </>
  );
};
